import { useSessionStore } from '@/common/stores/sessionStore'

export const OIDC_SECURED_APIS_BEFORE_SESSION_INIT = ['/api/v1/backend-event/token']

const isTargetUrlEligibleToTokenPropagation = function (originUrl: string, targetUrl: string): boolean {
  // Not starting with http -> eligible
  if (!targetUrl.startsWith('http')) return true
  // With same host, eligible
  const origin = new URL(originUrl)
  if (targetUrl.includes(origin.host)) return new URL(targetUrl).host === origin.host
  // Otherwise, no token propagated
  return false
}

export const isAccessTokenPropagationToRequestEnabled = function (originUrl: string, targetUrl: string): boolean {
  if (OIDC_SECURED_APIS_BEFORE_SESSION_INIT.includes(targetUrl)) return true // Manage early stage url that need token propagation
  if (!useSessionStore().oidcEnabled) return false
  return isTargetUrlEligibleToTokenPropagation(originUrl, targetUrl)
}
